import React, { Component } from 'react';
import FlipMove from 'react-flip-move';
import { Scrollbars } from 'react-custom-scrollbars';
import { TextField } from '@material-ui/core';
import UserOnlineUser from "./UserOnlineUser";

class UsersOnline extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filteredUsers: [],
            q: '',
            width: 0,
            height: 0,
        };

        this.filterList = this.filterList.bind(this);
        this.onChange = this.onChange.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.usersOnline !== this.props.usersOnline  && this.state.q === "") {
            this.setState({ filteredUsers: nextProps.usersOnline });
        }

        // No state update necessary
        return null;
    }

    onChange(event) {
        const q = event.target.value.toLowerCase();
        this.setState({ q }, () => this.filterList());
    }

    filterList() {
        let users = this.props.usersOnline;
        let q = this.state.q;
        users = users.filter(function(user) {
            return user.displayName.toLowerCase().startsWith(q);
        });
        this.setState({ filteredUsers: users });
    }

    render() {
        const onlineUsersComponents = this.state.filteredUsers.sort((a, b) => (
            b.rank - a.rank
        )).map((user) => (
            <div key={`${user.id}-user`}>
                <UserOnlineUser user={user} ranks={this.props.ranks} />
            </div>
        ));
        return (
            <div className={"left" + (this.props.open ? ' show' : '')} id="leftPanel">
                <div className="form-group">
                    <TextField
                        fullWidth
                        placeholder="Search Online Users"
                        value={this.state.q}
                        onChange={this.onChange}
                    />
                </div>
                <Scrollbars
                    renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                    renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                    autoHide
                    style={{height:this.state.height-78}}
                >
                    <FlipMove
                        staggerDelayBy={50}
                        appearAnimation="fade"
                        enterAnimation="fade"
                        leaveAnimation="fade"
                        typename="div"
                        className="list-group"
                    >
                        {onlineUsersComponents}
                        {
                            (this.props.anonymousUsers && !this.state.q) ?
                            (
                            <div className="list-group-item users-list-group-item" key="anonymous">
                                <span className="users-list-user adt-username">{this.props.anonymousUsers} Anonymous</span>
                            </div>
                            ) : (null)
                        }
                    </FlipMove>
                </Scrollbars>
            </div>
        );
    }
}

export default UsersOnline;


// WEBPACK FOOTER //
// ./src/UsersOnline/UsersOnline.js